import type { EntryValueViewT } from "@patient-watch/types";

export type EntryValueRowT =
    | { kind: "single"; entryValue: EntryValueViewT }
    | { kind: "checkboxes"; entryValues: EntryValueViewT[] };

/** Checkbox answers are stored as "true" / "Yes" / true; anything else is unticked. */
export function isCheckboxTicked(ev: EntryValueViewT): boolean {
    return ev.value === true || ev.value === "true" || ev.value === "Yes";
}

/**
 * Fold consecutive checkbox inputs (one multi-select list) into a single row so only the ticked
 * options show. A lone checkbox stays a normal row.
 */
export function groupCheckboxRuns(values: EntryValueViewT[]): EntryValueRowT[] {
    const rows: EntryValueRowT[] = [];
    let run: EntryValueViewT[] = [];

    const flush = () => {
        const [first] = run;
        if (run.length > 1) rows.push({ kind: "checkboxes", entryValues: run });
        else if (first) rows.push({ kind: "single", entryValue: first });
        run = [];
    };

    for (const ev of values) {
        if (ev.input_key === "checkbox") {
            if (run.length > 0 && run[0]?.page_index !== ev.page_index) flush();
            run.push(ev);
        } else {
            flush();
            rows.push({ kind: "single", entryValue: ev });
        }
    }
    flush();
    return rows;
}
